module.exports = __webpack_public_path__ + "img/no_address.77b0a6c6.svg";